import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminLayoutRoutes } from './auth-layout.routing';
import {LoginComponent} from '../../login/login.component';
import {ForgetPasswordComponent} from '../../forgetpassword/forgetpassword.component';
import {FeedBackComponent} from '../../feedback/feedback.component';
import {RestPasswordComponent} from '../../restpassword/restpassword.component';

import {MatCardModule} from '@angular/material/card';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatListModule} from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChangePasswordComponent } from 'app/ChangePassword/ChangePassword.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(AdminLayoutRoutes),
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatToolbarModule,
    MatSelectModule,
    MatTooltipModule,
    MatCardModule,
    MatDividerModule,
    MatExpansionModule,
    MatListModule
  ],
  declarations: [
    LoginComponent,
    ForgetPasswordComponent,
    FeedBackComponent,
    RestPasswordComponent,
    ChangePasswordComponent
  ]
})

export class AuthLayoutModule {}
